import { ICategory } from '@collections/categories/interfaces/category.interface';
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Renderer2, Inject, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { HallsService } from './halls.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DOCUMENT, NgClass } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { UserInteractionService } from 'app/shared/services/user-interaction/user-interaction.service';
import { RouterOutlet } from '@angular/router';
import { CarouselBannerComponent } from '../../../shared/components/carousel-banner/carousel-banner.component';
import { BreadcrumbComponent } from '../../../shared/components/breadcrumb/breadcrumb.component';
import { HallHeaderComponent } from './hall-header/hall-header.component';
import { RenderIfDirective } from '../../../shared/directives/render-if.directive';
import { UsersService } from 'app/shared/services/users/users.service';
import { CallToActionComponent } from 'app/shared/components/call-to-action/call-to-action.component';

@UntilDestroy()
@Component({
    selector: 'hall',
    templateUrl: './hall.component.html',
    styleUrls: ['./hall.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
      HallHeaderComponent,
      BreadcrumbComponent, 
      CarouselBannerComponent, 
      NgClass, 
      RouterOutlet, 
      RenderIfDirective,
      CallToActionComponent
    ]
})
export class HallComponent implements OnInit, OnDestroy {
  currentCategory: ICategory;
  showBanners = false
  showMore = false;

  
  constructor(
    public hallsService: HallsService,
    private platform: Platform,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    public userInteractionService: UserInteractionService,
    private cd: ChangeDetectorRef,
    public usersService: UsersService
  ) {
  }

  ngOnInit(): void {

    if (this.platform.isBrowser) {
      this.renderer.setStyle(this.document.body, '--main-content-contain', 'paint', 2);
    }
    this.hallsService.onCategoryChange
    .pipe(
      untilDestroyed(this)
    ).subscribe( cat => {
      this.renderer.setStyle(this.document.body, '--hall-color', `var(--${cat.cssClass})`, 2);
      this.renderer.setStyle(this.document.body, '--selected-hall-color', `var(--${cat.cssClass})`, 2);
      this.currentCategory = cat;
      this.showMore = false;
      this.cd.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this.platform.isBrowser) {
      this.renderer.setStyle(this.document.body, '--main-content-contain', 'layout', 2);
    }
  }
}
